export function IconDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
      {...props}
      width={props.width ? props.width : "44"} 
      height={props.height ? props.height : "30"} 
      fill={props.color ? props.color : "white"} 
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <polyline points="86 110 128 152 170 110" fill="none" stroke={props.color ? props.color : "#ffffff"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></polyline>
      <line x1="128" y1="40" x2="128" y2="152" fill="none" stroke={props.color ? props.color : "#ffffff"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></line>
      <path d="M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152" fill="none" stroke={props.color ? props.color : "#ffffff"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></path>
    </svg>
  );
}